import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import { Autocomplete } from "../../../components/Autocomplete";
import { Dialog } from "../../../components/Dialog";

export function SaveDialog({
  open,
  template,
  onChange,
  onClose,
  onEdit,
  onSave,
}) {
  return (
    <Dialog
      data-testid="template-content-dialog-save-template"
      maxWidth="sm"
      fullWidth
      title="Salvar Template"
      open={open}
      actions={[
        {
          children: "Salvar cópia",
          onClick: onSave,
        },
        {
          children: "Salvar",
          variant: "contained",
          onClick: template.idTemplate ? onEdit : onSave,
        },
      ]}
      onClose={onClose}
    >
      <Stack spacing={2} py={2}>
        <TextField
          size="small"
          data-testid="template-input-text-name"
          label="Nome"
          className="form-control"
          onChange={({ target }) => {
            onChange("templateName", target.value);
          }}
          value={template.templateName}
          fullWidth
        />
        <Autocomplete
          data-testid="template-autocomplete-type"
          fullWidth
          size="small"
          label="Tipo"
          getOptionLabel={(option) => option.label}
          placeholder="Selecione um valor"
          value={template.templateType}
          onChange={(option) => onChange("templateType", option)}
          options={[
            { value: "html", label: "Email" },
            { value: "html", label: "Landing Page" },
          ]}
        />
      </Stack>
    </Dialog>
  );
}
